import React, { KeyboardEventHandler, useContext, useRef } from "react"
import tw from "twin.macro"
import { LanguageContext } from "../../context/Language"
import { AcceptedLanguage } from "../../context/Language/language.d"
import useOpenDropdown from "../../hooks/useOpenDropdown"
import MenuArrow from "../Icons/MenuArrow"

const MobileMenuLanguage: React.FC = () => {
  const ref = useRef(null)
  const { open, setOpen, hover, setHover } = useOpenDropdown(ref)
  const { language, languageOptions, setLanguage } = useContext(LanguageContext)

  const handleMouseDown = () => {
    setOpen(!open)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleMouseDown()
    }
  }

  const handleBlur = (e: React.FocusEvent) => {
    if (!ref.current.contains(e.relatedTarget)) {
      setOpen(false)
    }
  }

  const handleChangeLanguage = (languageCode: AcceptedLanguage) => {
    setLanguage(languageCode)
    setOpen(false)
  }

  return (
    <div
      ref={ref}
      css={[
        tw`tracking-tight text-3.75 self-end mr-4 mb-2 relative w-60 flex justify-end w-full`,
      ]}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <button
        type="button"
        css={[
          tw`p-2 transition-colors duration-500 flex items-center transition-all text-grayBlack bg-sand font-body self-end`,
          open ? tw`rounded-t shadow-dropdown` : tw`rounded`,
        ]}
        style={{ outlineColor: "#AED1D3", outlineOffset: "5px" }}
        aria-label={`${open ? "close" : "open"} mobile language dropdown`}
        aria-expanded={open}
        aria-controls="languageDropdownMobile"
        onMouseDown={handleMouseDown}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
      >
        Language:{" "}
        <span css={[tw`ml-1 font-semibold`]}>{language?.toUpperCase()}</span>
        <MenuArrow type={open ? "up" : "down"} color="#4b4143" />
      </button>
      <div
        id="languageDropdownMobile"
        css={[
          tw`absolute z-10 top-[100%] bg-sand shadow-dropdown overflow-hidden transition-max-h ease-max-h-hide duration-max-h-hide max-h-0 border border-transparent`,
          open && tw`max-h-screen ease-max-h-show duration-max-h-show`,
        ]}
      >
        {languageOptions?.map(({ label, value }) => (
          <div key={label} css={[tw`w-full px-5`]}>
            <button
              type="button"
              css={[
                tw`block text-grayBlack text-left h-6 my-4 hover:underline focus:underline`,
              ]}
              onClick={() => handleChangeLanguage(value)}
              onBlur={handleBlur}
              style={{ outlineColor: "#AED1D3", outlineOffset: "5px" }}
              tabIndex={!open && -1}
            >
              {label}
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MobileMenuLanguage
